/**
 * Brand wordmark — English on the public site (not passed through i18n).
 */
export const SITE_BRAND_MARK = 'AI Restro 360'

/** @deprecated Prefer SITE_BRAND_MARK — alias for Vite parity */
export const SITE_NAME = SITE_BRAND_MARK

/** Header logo (`public/logos/airestro360.png`). */
export const LOGO_SRC = '/logos/airestro360.png'

/** Footer on dark background (`public/logos/airestro360-white.png`). */
export const FOOTER_LOGO_SRC = '/logos/airestro360-white.png'
